
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { PortfolioSection } from './components/PortfolioSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import { ContactSection } from './components/ContactSection';
import { Phone } from 'lucide-react';

const HomePage: React.FC = () => {
  const handleCallClick = () => {
    window.open('tel:+1-555-VISTA-01', '_self');
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <PortfolioSection />
        <TestimonialsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      
      {/* Floating Call Button */}
      <button
        onClick={handleCallClick}
        className="fixed bottom-6 right-6 bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-50 cursor-pointer"
        aria-label="Call VistaBoost Imaging"
      >
        <Phone size={24} />
      </button>
    </div>
  );
};

export default HomePage;
